import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=5f697c20&scoped=true&"
import script from "./SingleProduct.vue?vue&type=script&lang=js&"
export * from "./SingleProduct.vue?vue&type=script&lang=js&"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=5f697c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f697c20",
  null
  
)

export default component.exports